const Login = () => import(/* webpackChunkName: "v-login" */ '@/components/page/login/Login')
const ForgotPassword = () => import(/* webpackChunkName: "v-login" */ '@/components/page/login/ForgotPassword')
const ResetPassword = () => import(/* webpackChunkName: "v-login" */ '@/components/page/login/ResetPassword')
const ValidateUser = () => import(/* webpackChunkName: "v-login" */ '@/components/page/login/ValidateUser')

const routes = [
  {
    path: '/login',
    component: Login
  }, {
    path: '/forgotPassword',
    component: ForgotPassword
  }, {
    name: 'resetPassword',
    path: '/resetPassword',
    component: ResetPassword
  }, {
    path: '/validateUser',
    component: ValidateUser
  }
]

export default routes
